import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de fungicidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarFungicida(props) {
  useEffect(() => {
    const title = 'fungicida.cadastroDeFungicida';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'fungicidas'}
      insumoEnum={Insumo.FUNGICIDA}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'fungicida.' +
          (props.match.params.id
            ? 'fungicidaEditadoComSucesso'
            : 'fungicidaCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'fungicida.' +
          (props.match.params.id
            ? 'falhaAoEditarFungicida'
            : 'falhaAoCadastrarFungicida')
      )}
      falhaCarregarMensagem={formatMessage('fungicida.falhaAoCarregarFungicida')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarFungicida));
